import { Notification } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "../i18n";
import { IRootState } from "../store";

const FailedMessage: React.FC<any> = ({ failedMessage }: { failedMessage: { show: boolean; text: string } }) => {
  const t = useTranslation();

  return (
    <>
      {failedMessage.text !== "" && (
        <Notification
          styles={{
            icon: {
              color: "red",
            },
            root: {
              border: "1px solid lightgray",
            },
          }}
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            margin: "25px",
            zIndex: 10000000,
          }}
          withBorder={true}
          withCloseButton={false}
          icon={<IconX size={20} />}
          title={t("common.error")}
        >
          {failedMessage.text?.split("\n").map((row: string, i: number) => (
            <div key={i}>{row}</div>
          ))}
        </Notification>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  failedMessage: state.globalReducer.failedMessage,
});

export default connect(mapStateToProps, {})(FailedMessage);
